import { createAction } from 'redux-actions'
import { actionTypes } from 'common/store/orders/constants'

// eslint-disable-next-line import/prefer-default-export
export const updateOrdersComment = createAction(actionTypes.UPDATE_ORDERS_COMMENT)
